"use client"

import { Link } from "react-router"
import { useLanguage } from "@web/lib/contexts/language-context"

export const NotFoundPage = () => {
	const { t } = useLanguage()

	return (
		<div className="flex flex-col items-center justify-center gap-4 py-16 md:py-24">
			<h1 className="font-bold text-3xl text-primary">{t.notFoundPage.title}</h1>
			<p className="text-muted-foreground">{t.notFoundPage.message}</p>
			<p className="text-muted-foreground">
				{t.notFoundPage.backText}{" "}
				<Link className="font-medium text-primary hover:underline" to={"/"}>
					{t.notFoundPage.homeLink}
				</Link>
				.
			</p>
		</div>
	)
}
